(() => {
  'use strict';


  /* ==========================================================
     SOUL BY CHI
     HOMEPAGE V2 — CLEAN / STABLE
     ========================================================== */


  const REDUCED_MOTION =
    window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    );


  const FINE_POINTER =
    window.matchMedia(
      '(hover: hover) and (pointer: fine)'
    );


  const HERO_DURATION = 6400;



  /* ==========================================================
     INITIALIZE
     ========================================================== */

  function initSoulByChi(
    scope = document
  ) {

    const homes =
      scope.matches?.(
        '[data-sbc-home]'
      )
        ? [scope]
        : scope.querySelectorAll?.(
            '[data-sbc-home]'
          );


    if (!homes) {
      return;
    }


    homes.forEach(
      (home) => {


        if (
          home.dataset.sbcInitialized ===
          'true'
        ) {
          return;
        }


        home.dataset.sbcInitialized =
          'true';


        initMobileMenu(home);

        initHeader(home);

        initHero(home);

        initScrollReveals(home);

        initProductCards(home);

        initMagneticButtons(home);

        initStoryParallax(home);


        requestAnimationFrame(
          () => {

            requestAnimationFrame(
              () => {

                home.classList.add(
                  'is-ready'
                );

              }
            );

          }
        );

      }
    );

  }



  /* ==========================================================
     MOBILE MENU
     ========================================================== */

  function initMobileMenu(home) {

    const toggle =
      home.querySelector(
        '[data-sbc-mobile-toggle]'
      );


    const menu =
      home.querySelector(
        '[data-sbc-mobile-menu]'
      );


    if (
      !toggle ||
      !menu
    ) {
      return;
    }


    function closeMenu() {

      toggle.classList.remove(
        'is-open'
      );


      menu.classList.remove(
        'is-open'
      );


      toggle.setAttribute(
        'aria-expanded',
        'false'
      );

    }


    toggle.addEventListener(
      'click',
      () => {

        const willOpen =
          !menu.classList.contains(
            'is-open'
          );


        toggle.classList.toggle(
          'is-open',
          willOpen
        );


        menu.classList.toggle(
          'is-open',
          willOpen
        );


        toggle.setAttribute(
          'aria-expanded',
          String(willOpen)
        );

      }
    );


    menu
      .querySelectorAll('a')
      .forEach(
        (link) => {

          link.addEventListener(
            'click',
            closeMenu
          );

        }
      );


    document.addEventListener(
      'keydown',
      (event) => {

        if (
          event.key ===
          'Escape'
        ) {

          closeMenu();

        }

      }
    );

  }



  /* ==========================================================
     HEADER
     ========================================================== */

  function initHeader(home) {

    const header =
      home.querySelector(
        '[data-sbc-header]'
      );


    if (!header) {
      return;
    }


    let ticking =
      false;


    function updateHeader() {

      ticking =
        false;


      header.classList.toggle(
        'is-compact',
        window.scrollY > 75
      );

    }


    function requestUpdate() {

      if (ticking) {
        return;
      }


      ticking =
        true;


      requestAnimationFrame(
        updateHeader
      );

    }


    updateHeader();


    window.addEventListener(
      'scroll',
      requestUpdate,
      {
        passive: true
      }
    );

  }



  /* ==========================================================
     HERO
     ========================================================== */

  function initHero(home) {

    const hero =
      home.querySelector(
        '[data-sbc-hero]'
      );


    if (!hero) {
      return;
    }


    const stage =
      hero.querySelector(
        '[data-sbc-hero-stage]'
      );


    const slides = [
      ...hero.querySelectorAll(
        '[data-sbc-slide]'
      )
    ];


    const copies = [
      ...hero.querySelectorAll(
        '[data-sbc-scene-copy]'
      )
    ];
    const floatingProducts = [
  ...hero.querySelectorAll(
    '[data-sbc-floating-product]'
  )
];


const textureCards = [
  ...hero.querySelectorAll(
    '[data-sbc-texture-card]'
  )
];


    const currentCounter =
      hero.querySelector(
        '[data-sbc-current]'
      );


    const totalCounter =
      hero.querySelector(
        '[data-sbc-total]'
      );


    const progress =
      hero.querySelector(
        '[data-sbc-progress]'
      );


    if (
      slides.length === 0
    ) {
      return;
    }


    let currentIndex =
      0;


    let timer =
      null;


    let pointerFrame =
      null;


    let scrollFrame =
      null;



    /* ======================================================
       COLORS
       ====================================================== */

    const accents = [

      '176, 111, 66',

      '143, 100, 85',

      '76, 51, 42'

    ];



    /* ======================================================
       PROGRESS BUTTONS
       ====================================================== */

    const progressButtons =
      [];


    if (progress) {

      progress.innerHTML =
        '';


      slides.forEach(
        (_, slideIndex) => {


          const button =
            document.createElement(
              'button'
            );


          button.type =
            'button';


          button.setAttribute(
            'aria-label',
            (document.body.dataset.sbcHeroImage || '').replace('__number__', slideIndex + 1)
          );


          button.addEventListener(
            'click',
            () => {

              showSlide(
                slideIndex
              );

              restartTimer();

            }
          );


          progress.appendChild(
            button
          );


          progressButtons.push(
            button
          );

        }
      );

    }



    /* ======================================================
       COUNTER
       ====================================================== */

    if (totalCounter) {

      totalCounter.textContent =
        String(
          slides.length
        ).padStart(
          2,
          '0'
        );

    }



    /* ======================================================
       SHOW SLIDE
       ====================================================== */

    function showSlide(
      nextIndex
    ) {

      currentIndex =
        (
          nextIndex +
          slides.length
        ) %
        slides.length;


      slides.forEach(
        (slide, index) => {

          slide.classList.toggle(
            'is-active',
            index === currentIndex
          );

        }
      );


      copies.forEach(
        (copy, index) => {

          copy.classList.toggle(
            'is-active',
            index === currentIndex
          );

        }
      );
floatingProducts.forEach(
  (product, index) => {

    product.classList.toggle(
      'is-active',
      index === currentIndex
    );

  }
);


textureCards.forEach(
  (texture, index) => {

    texture.classList.toggle(
      'is-active',
      index === currentIndex
    );

  }
);

      if (currentCounter) {

        currentCounter.textContent =
          String(
            currentIndex + 1
          ).padStart(
            2,
            '0'
          );

      }


      hero.style.setProperty(
        '--scene-accent',
        accents[
          currentIndex %
          accents.length
        ]
      );


      progressButtons.forEach(
        (button, index) => {

          button.classList.remove(
            'is-active'
          );


          if (
            index ===
            currentIndex
          ) {

            /*
              Force CSS progress animation
              to restart.
            */

            void button.offsetWidth;


            button.classList.add(
              'is-active'
            );

          }

        }
      );

    }



    /* ======================================================
       AUTO SLIDER
       ====================================================== */

    function stopTimer() {

      if (timer) {

        clearTimeout(
          timer
        );

      }


      timer =
        null;

    }


    function startTimer() {

      stopTimer();


      if (
        REDUCED_MOTION.matches ||
        document.hidden ||
        slides.length <= 1
      ) {
        return;
      }


      timer =
        window.setTimeout(
          () => {

            showSlide(
              currentIndex + 1
            );


            startTimer();

          },

          HERO_DURATION
        );

    }


    function restartTimer() {

      stopTimer();

      startTimer();

    }



    /* ======================================================
       HERO POINTER PARALLAX
       ====================================================== */

    if (
      FINE_POINTER.matches &&
      !REDUCED_MOTION.matches
    ) {

     hero.addEventListener(
        'pointermove',
        (event) => {


          if (pointerFrame) {

            cancelAnimationFrame(
              pointerFrame
            );

          }


          pointerFrame =
            requestAnimationFrame(
              () => {


                const rect =
                  hero.getBoundingClientRect();


                const x =
                  (
                    event.clientX -
                    rect.left
                  ) /
                  Math.max(
                    rect.width,
                    1
                  );


                const y =
                  (
                    event.clientY -
                    rect.top
                  ) /
                  Math.max(
                    rect.height,
                    1
                  );


                const normalizedX =
                  (
                    x - .5
                  ) * 2;


                const normalizedY =
                  (
                    y - .5
                  ) * 2;


                hero.style.setProperty(
                  '--hero-x',
                  normalizedX.toFixed(
                    3
                  )
                );


                hero.style.setProperty(
                  '--hero-y',
                  normalizedY.toFixed(
                    3
                  )
                );


                hero.style.setProperty(
                  '--pointer-x',
                  `${x * 100}%`
                );


                hero.style.setProperty(
                  '--pointer-y',
                  `${y * 100}%`
                );

              }
            );

        }
      );


      hero.addEventListener(
        'pointerleave',
        () => {

          hero.style.setProperty(
            '--hero-x',
            '0'
          );


          hero.style.setProperty(
            '--hero-y',
            '0'
          );


          hero.style.setProperty(
            '--pointer-x',
            '70%'
          );


          hero.style.setProperty(
            '--pointer-y',
            '35%'
          );

        }
      );

    }



    /* ======================================================
       HERO SCROLL DEPTH
       ====================================================== */

    function updateHeroScroll() {

      scrollFrame =
        null;


      if (
        REDUCED_MOTION.matches
      ) {
        return;
      }


      const rect =
        hero.getBoundingClientRect();


      const progressValue =
        Math.min(
          1,
          Math.max(
            0,
            -rect.top /
            Math.max(
              rect.height,
              1
            )
          )
        );


      hero.style.setProperty(
        '--hero-scroll',
        progressValue.toFixed(
          3
        )
      );

    }


    function requestHeroScroll() {

      if (scrollFrame) {
        return;
      }


      scrollFrame =
        requestAnimationFrame(
          updateHeroScroll
        );

    }


    updateHeroScroll();


    window.addEventListener(
      'scroll',
      requestHeroScroll,
      {
        passive: true
      }
    );



    /* ======================================================
       TAB VISIBILITY
       ====================================================== */

    document.addEventListener(
      'visibilitychange',
      () => {

        if (
          document.hidden
        ) {

          stopTimer();

        } else {

          startTimer();

        }

      }
    );



    /* ======================================================
       INITIAL
       ====================================================== */

    showSlide(0);

    startTimer();

  }



  /* ==========================================================
     PRODUCT CARDS
     ========================================================== */

  function initProductCards(home) {

    const grid =
      home.querySelector(
        '[data-sbc-product-grid]'
      );


    if (!grid) {
      return;
    }


    const cards = [
      ...grid.querySelectorAll(
        '.sbc-card'
      )
    ];


    cards.forEach(
      (card, cardIndex) => {


        card.style.setProperty(
          '--card-delay',
          `${cardIndex * 105}ms`
        );


        if (
          !FINE_POINTER.matches ||
          REDUCED_MOTION.matches
        ) {
          return;
        }


        const media =
          card.querySelector(
            '.sbc-card__media'
          );


        if (!media) {
          return;
        }


        let animationFrame =
          null;


        media.addEventListener(
          'pointermove',
          (event) => {


            if (animationFrame) {

              cancelAnimationFrame(
                animationFrame
              );

            }


            animationFrame =
              requestAnimationFrame(
                () => {


                  const rect =
                    media.getBoundingClientRect();


                  const x =
                    (
                      event.clientX -
                      rect.left
                    ) /
                    Math.max(
                      rect.width,
                      1
                    );


                  const y =
                    (
                      event.clientY -
                      rect.top
                    ) /
                    Math.max(
                      rect.height,
                      1
                    );


                  const rotateX =
                    (
                      .5 - y
                    ) * 4.2;


                  const rotateY =
                    (
                      x - .5
                    ) * 4.2;


                  card.style.setProperty(
                    '--card-rx',
                    `${rotateX.toFixed(2)}deg`
                  );


                  card.style.setProperty(
                    '--card-ry',
                    `${rotateY.toFixed(2)}deg`
                  );


                  card.style.setProperty(
                    '--card-x',
                    `${x * 100}%`
                  );


                  card.style.setProperty(
                    '--card-y',
                    `${y * 100}%`
                  );

                }
              );

          }
        );


        media.addEventListener(
          'pointerleave',
          () => {


            card.style.setProperty(
              '--card-rx',
              '0deg'
            );


            card.style.setProperty(
              '--card-ry',
              '0deg'
            );


            card.style.setProperty(
              '--card-x',
              '50%'
            );


            card.style.setProperty(
              '--card-y',
              '50%'
            );

          }
        );

      }
    );

  }



  /* ==========================================================
     MAGNETIC BUTTONS
     ========================================================== */

  function initMagneticButtons(
    home
  ) {

    if (
      !FINE_POINTER.matches ||
      REDUCED_MOTION.matches
    ) {
      return;
    }


    const buttons =
      home.querySelectorAll(
        '.sbc-button'
      );


    buttons.forEach(
      (button) => {


        button.addEventListener(
          'pointermove',
          (event) => {


            const rect =
              button.getBoundingClientRect();


            const x =
              event.clientX -
              rect.left -
              rect.width / 2;


            const y =
              event.clientY -
              rect.top -
              rect.height / 2;


            button.style.setProperty(
              '--button-x',
              `${x * .075}px`
            );


            button.style.setProperty(
              '--button-y',
              `${y * .105}px`
            );

          }
        );


        button.addEventListener(
          'pointerleave',
          () => {


            button.style.setProperty(
              '--button-x',
              '0px'
            );


            button.style.setProperty(
              '--button-y',
              '0px'
            );

          }
        );

      }
    );

  }



  /* ==========================================================
     SCROLL REVEALS
     ========================================================== */

  function initScrollReveals(
    home
  ) {

    const selectors = [

      '.sbc-intro .sbc-eyebrow',

      '.sbc-intro h2',

      '.sbc-section-heading',

      '.sbc-story__media',

      '.sbc-story__content .sbc-eyebrow',

      '.sbc-story__content h2',

      '.sbc-story__text',

      '.sbc-story__content .sbc-button',

      '.sbc-values__heading',

      '.sbc-value',

      '.sbc-newsletter__copy',

      '.sbc-newsletter__form-wrap',

      '.sbc-footer__brand',

      '.sbc-footer__nav'

    ];


    const elements =
      home.querySelectorAll(
        selectors.join(',')
      );


    elements.forEach(
      (element) => {

        element.classList.add(
          'sbc-reveal'
        );

      }
    );


    const productGrid =
      home.querySelector(
        '[data-sbc-product-grid]'
      );



    /* Reduced motion */

    if (
      REDUCED_MOTION.matches ||
      !(
        'IntersectionObserver'
        in window
      )
    ) {

      elements.forEach(
        (element) => {

          element.classList.add(
            'is-visible'
          );

        }
      );


      if (productGrid) {

        productGrid.classList.add(
          'is-visible'
        );

      }


      return;

    }



    /* Intersection observer */

    const observer =
      new IntersectionObserver(

        (
          entries,
          currentObserver
        ) => {


          entries.forEach(
            (entry) => {


              if (
                !entry.isIntersecting
              ) {
                return;
              }


              entry.target.classList.add(
                'is-visible'
              );


              currentObserver.unobserve(
                entry.target
              );

            }
          );

        },

        {
          threshold: .12,

          rootMargin:
            '0px 0px -8% 0px'
        }

      );


    elements.forEach(
      (element) => {

        observer.observe(
          element
        );

      }
    );


    if (productGrid) {

      observer.observe(
        productGrid
      );

    }

  }



  /* ==========================================================
     STORY PARALLAX
     ========================================================== */

  function initStoryParallax(
    home
  ) {

    if (
      REDUCED_MOTION.matches
    ) {
      return;
    }


    const story =
      home.querySelector(
        '.sbc-story'
      );


    const image =
      home.querySelector(
        '.sbc-story__image'
      );


    if (
      !story ||
      !image
    ) {
      return;
    }


    let frame =
      null;


    function update() {

      frame =
        null;


      if (
        window.innerWidth <= 800
      ) {

        image.style.setProperty(
          '--story-y',
          '0px'
        );


        return;
      }


      const rect =
        story.getBoundingClientRect();


      if (
        rect.bottom < 0 ||
        rect.top >
        window.innerHeight
      ) {
        return;
      }


      const center =
        rect.top +
        rect.height / 2 -
        window.innerHeight / 2;


      const y =
        Math.max(
          -38,
          Math.min(
            38,
            center * -.05
          )
        );


      image.style.setProperty(
        '--story-y',
        `${y}px`
      );

    }


    function requestUpdate() {

      if (frame) {
        return;
      }


      frame =
        requestAnimationFrame(
          update
        );

    }


    update();


    window.addEventListener(
      'scroll',
      requestUpdate,
      {
        passive: true
      }
    );


    window.addEventListener(
      'resize',
      requestUpdate
    );

  }



  /* ==========================================================
     DOM READY
     ========================================================== */

  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      () => {

        initSoulByChi(
          document
        );

      },
      {
        once: true
      }
    );

  } else {

    initSoulByChi(
      document
    );

  }



  /* ==========================================================
     SHOPIFY THEME EDITOR
     ========================================================== */

  document.addEventListener(
    'shopify:section:load',
    (event) => {

      initSoulByChi(
        event.target
      );

    }
  );

})();
